import { useEffect } from "react";

export interface HdmgdjSeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function applyMeta(name: string, content?: string) {
  const existing = document.head.querySelector<HTMLMetaElement>(
    `meta[name="${name}"]`
  );
  if (!content) {
    if (existing) {
      existing.parentNode?.removeChild(existing);
    }
    return;
  }
  if (!existing) {
    const meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
    meta.setAttribute("content", content);
    return;
  }
  existing.setAttribute("content", content);
}

/**
 * 单页应用内按路由切换标题 / 描述 / 关键词。
 * 传空（或不传）描述、关键词时会移除对应 meta 标签。
 */
export function useHdmgdjSeo({ title, description, keywords }: HdmgdjSeoOptions) {
  useEffect(() => {
    document.title = title;
    applyMeta("description", description);
    applyMeta("keywords", keywords);
  }, [title, description, keywords]);
}